/**
 * features/reports/hooks.ts
 */

import { useQuery } from '@tanstack/react-query';
import { api, queryString } from '~/lib/api';
import { queryKeys } from '~/lib/query-client';
import type { DashboardSummary, MonthlySeriesPoint, VatReport } from '~/lib/types';

export function useDashboard(year: number, month: number) {
  return useQuery({
    queryKey: queryKeys.dashboard(year, month),
    queryFn: () => api.get<DashboardSummary>(`/api/reports/dashboard${queryString({ year, month })}`),
  });
}

export function useMonthlySeries(year: number) {
  return useQuery({
    queryKey: queryKeys.monthlySeries(year),
    queryFn: () => api.get<MonthlySeriesPoint[]>(`/api/reports/monthly-series${queryString({ year })}`),
  });
}

export function useVatReport(year: number, month: number) {
  return useQuery({
    queryKey: queryKeys.vatReport(year, month),
    queryFn: () => api.get<VatReport>(`/api/reports/vat${queryString({ year, month })}`),
  });
}
